import { Box, Breadcrumbs, Paper, Skeleton } from "@mui/material";
import { ReactNode } from "react";

export type UserProfileSkeletonProps = {
  breadcrumbs: ReactNode[];
};

export function UserProfileSkeleton({ breadcrumbs }: UserProfileSkeletonProps) {
  return (
    <Box>
      <Breadcrumbs sx={{ mb: 3, overflowWrap: "anywhere" }} separator="›">
        {breadcrumbs}
      </Breadcrumbs>

      {/* Back link skeleton */}
      <Skeleton variant="text" width={120} height={24} sx={{ mb: 2 }} />

      {/* User header skeleton */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
        <Skeleton variant="circular" width={80} height={80} />
        <Box>
          <Skeleton variant="text" width={200} height={40} />
          <Skeleton variant="text" width={150} height={24} />
        </Box>
      </Box>

      {/* Profile card skeleton */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
        <Skeleton variant="text" width={120} height={28} sx={{ mb: 2 }} />
        <Box sx={{ display: "flex", gap: 3, mb: 3 }}>
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={60} height={20} sx={{ mb: 1 }} />
            <Skeleton variant="rectangular" height={40} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={100} height={20} sx={{ mb: 1 }} />
            <Skeleton variant="rectangular" height={40} />
          </Box>
        </Box>
        <Skeleton variant="text" width={140} height={20} sx={{ mb: 1 }} />
        <Skeleton variant="rectangular" height={56} />
      </Paper>

      {/* Space access table skeleton */}
      <Paper sx={{ p: 3, borderRadius: 2 }}>
        <Skeleton variant="text" width={220} height={28} sx={{ mb: 1 }} />
        <Skeleton variant="text" width={350} height={20} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={40} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={300} />
      </Paper>
    </Box>
  );
}
